import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AdministrationMenuActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Menu/MenuBrowser")
	}

	render() {
		return (
			<Activity 
				name="AdministrationMenu"
				RenderedComponent={this.RenderedComponent}
				context="AdministrationMenu"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AdministrationMenuActivity)
